'use client';
import React, { useEffect, useRef } from 'react';

const BOOKING_URL = 'https://revmy.ro/service-provider-profile/botosani/detailing/asa-detailing';

export default function BookingSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) obs?.observe(sectionRef?.current);
    return () => obs?.disconnect();
  }, []);

  return (
    <section id="book" ref={sectionRef} className="py-24 md:py-36" style={{ background: 'var(--cockpit-black)' }}>
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="metric-pill mb-6 reveal inline-flex">Programare</div>

        <h2
          className="font-manrope font-extrabold text-white reveal reveal-delay-1"
          style={{ fontSize: 'clamp(32px, 5vw, 60px)', letterSpacing: '-0.03em', lineHeight: 1.05 }}
        >
          Gata să îți transformi<br />
          <span style={{ color: 'var(--ceramic-blue)' }}>mașina?</span>
        </h2>

        <p
          className="mt-5 mb-8 reveal reveal-delay-2 leading-relaxed"
          style={{ color: 'var(--aluminum-dim)', fontSize: '17px' }}
        >
          Programează-te rapid și simplu prin platforma RevMy.ro.
        </p>

        {/* Contact info */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12 reveal reveal-delay-3">
          <div
            className="flex items-center gap-3 rounded-xl px-5 py-3"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(63,63,70,0.5)' }}
          >
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ color: 'var(--ceramic-blue)', flexShrink: 0 }}>
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="9" r="2.5"/>
            </svg>
            <span style={{ fontSize: '14px', color: 'var(--aluminum-dim)', fontFamily: 'DM Sans, sans-serif' }}>
              E58 79 Mănăstirea Doamnei, 717114 Botoșani
            </span>
          </div>
          <div
            className="flex items-center gap-3 rounded-xl px-5 py-3"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(63,63,70,0.5)' }}
          >
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ color: 'var(--ceramic-blue)', flexShrink: 0 }}>
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.38 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.56a16 16 0 0 0 6 6l.92-.92a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <a
              href="tel:0787408552"
              style={{ fontSize: '14px', color: 'var(--aluminum-dim)', fontFamily: 'DM Sans, sans-serif', textDecoration: 'none' }}
            >
              0787 408 552
            </a>
          </div>
        </div>

        {/* Big CTA Button */}
        <div className="reveal reveal-delay-4">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 font-manrope font-extrabold text-white rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            style={{
              background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
              fontSize: 'clamp(18px, 2.5vw, 24px)',
              padding: '22px 52px',
              letterSpacing: '-0.01em',
              boxShadow: '0 8px 40px rgba(59,130,246,0.35)',
              border: '1px solid rgba(59,130,246,0.5)',
            }}
          >
            Programează-te pe RevMy.ro
            <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <p className="mt-5" style={{ fontSize: '13px', color: 'var(--aluminum-faint)', fontFamily: 'DM Sans, sans-serif' }}>
            Vei fi redirecționat către platforma RevMy.ro pentru programare
          </p>
        </div>
      </div>
    </section>
  );
}
